import axios from 'axios';

export default {
  index: (params = {}, config = {}) => axios.get('tags', { params, ...config }),
};
